module.exports = __webpack_public_path__ + "static/media/my-account-bg.27048616.jpg";